/* Gridline — faceted filtering helper (collection + search templates).
   - All facet inputs associate to #FacetsForm via the form="" attribute, so
     the desktop sidebar and the mobile drawer feed one GET form.
   - Any facet change auto-submits (debounced). The sort <select> lives outside
     the form; it syncs a hidden sort_by input, then submits.
   - The drawer copy is marked [data-facets-dup]: it is mirrored on change and
     disabled at submit time so params are not duplicated.
   - Empty number inputs are disabled at submit time to keep URLs clean.
   No-ops on pages without #FacetsForm. */
(function () {
  'use strict';

  var form = document.getElementById('FacetsForm');
  if (!form) return;

  var timer = null;

  function prepare() {
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.hasAttribute('data-facets-dup')) {
        el.disabled = true;
        return;
      }
      if (el.type === 'number' && el.value.trim() === '') el.disabled = true;
    });
  }

  function submitNow() {
    clearTimeout(timer);
    prepare();
    form.submit();
  }

  function queueSubmit() {
    clearTimeout(timer);
    timer = setTimeout(submitNow, 350);
  }

  /* Mirror a change to the twin input in the other copy (sidebar <-> drawer). */
  function syncTwins(el) {
    if (!el.name) return;
    Array.prototype.forEach.call(form.elements, function (twin) {
      if (twin === el || twin.name !== el.name) return;
      if (el.type === 'checkbox') {
        if (twin.value === el.value) twin.checked = el.checked;
      } else if (twin.type === el.type) {
        twin.value = el.value;
      }
    });
  }

  /* Native submits: Apply button in the drawer, Enter inside a price input. */
  form.addEventListener('submit', function () {
    clearTimeout(timer);
    prepare();
  });

  document.addEventListener('change', function (e) {
    var el = e.target;

    if (el.form === form && !el.hasAttribute('data-facets-sort-input')) {
      syncTwins(el);
      queueSubmit();
      return;
    }

    if (el.hasAttribute && el.hasAttribute('data-facets-sort')) {
      var hidden = form.querySelector('[data-facets-sort-input]');
      if (hidden) hidden.value = el.value;
      submitNow();
    }
  });

  /* Tag-fallback links inside the mobile drawer trigger full navigation, which
     closes the drawer. Flag the intent so the next page reopens it and the
     shopper can keep stacking filters. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('#FacetsDrawer .dc-facet__option--link');
    if (!link) return;
    try { sessionStorage.setItem('dcReopenFacets', '1'); } catch (err) {}
  });

  try {
    if (sessionStorage.getItem('dcReopenFacets') === '1') {
      sessionStorage.removeItem('dcReopenFacets');
      var opener = document.querySelector('[data-drawer-open="FacetsDrawer"]');
      if (opener && document.getElementById('FacetsDrawer')) opener.click();
    }
  } catch (err) {}
})();
